import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Guide.module.css';
import airdropImage from './airdrop.png';
import useStore from '../../../hooks/useStore';
import Share from '../Dashboard/Share/Share';

const Guide = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [showShareModal, setShowShareModal] = useState(false);
  const { 
    address,
    connectWithChainSwitch, 
    mintNFT, 
    isConnecting, 
    isMinting,
    userStatus
  } = useStore();

  const { is_checked_in } = userStatus;

  const handleConnect = async () => {
    try {
      await connectWithChainSwitch(() => {
        navigate('/dashboard');
      });
    } catch (error) {
      console.error('Connection failed:', error);
    }
  };

  const handleMint = async () => {
    try {
      const { success } = await mintNFT();
      if (success) {
        navigate('/dashboard');
        setTimeout(() => {
          setShowShareModal(true);
        }, 300);
      }
    } catch (error) {
      console.error('Mint failed:', error);
    }
  };

  const handleCloseShare = () => {
    setShowShareModal(false);
  };

  if (!isOpen || is_checked_in && !showShareModal) return null;
  
  if (showShareModal) {
    return <Share onClose={handleCloseShare} />;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>✕</button>
        <div className={styles.content}>
          <img src={airdropImage} alt="Airdrop" className={styles.airdropImage} />
          <span className={styles.mainTitle}>MINO Airdrop Mission</span>
          <span className={styles.description}>
            Mint your MINO Avatar and get $50 MINO — invite your friends and earn more!
          </span>
          <span className={styles.title}>How It Works?</span>
          <ul className={styles.steps}>
            <li><span className={styles.stepNumber}>1</span> Mint your MINO Avatar NFT for free to get $50 worth of $MINO</li>
            <li><span className={styles.stepNumber}>2</span> Invite friends using your unique link</li>
            <li><span className={styles.stepNumber}>3</span> Earn 15,000 $MINO tokens for each friend you invite</li>
          </ul>
          <div className={styles.extraInfo}>
            <span className={styles.extraTitle}>🟦 🟨 🟧 More = More:</span>
            <p>For every 4 invitees who complete the task, you earn +1 Tetromino NFT(With 30,000 extra $MINO)<br/>(Invite 8 = +2 Tetromino NFTs, 12 = +3 Tetromino NFTs... and so on)</p>
          </div>
          <button 
            className={`${styles.mintButton} ${(isConnecting || isMinting) ? styles.minting : ''}`} 
            onClick={address ? handleMint : handleConnect}
            disabled={isConnecting || isMinting}
          >
            {isConnecting ? 'Connecting...' : 
             !address ? 'Connect Wallet' :
             isMinting ? 'Minting...' : 
             'Mint and Get Started'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Guide;
